export let SettingsTypes = /*#__PURE__*/function (SettingsTypes) {
  SettingsTypes["TurnaroundTime"] = "TurnaroundTime";
  SettingsTypes["FlatRates"] = "FlatRates";
  SettingsTypes["SuperSpeed"] = "SuperSpeed";
  SettingsTypes["DefaultWarehouse"] = "DefaultWarehouse";
  SettingsTypes["ShippingMargin"] = "ShippingMargin";
  SettingsTypes["MostPopularGoodieBudget"] = "MostPopularGoodieBudget";
  SettingsTypes["GoodieFlatRates"] = "GoodieFlatRates";
  SettingsTypes["CrinklePaperSku"] = "CrinklePaperSku";
  SettingsTypes["ReplacementPriceRange"] = "ReplacementPriceRange";
  SettingsTypes["HubspotCalendarLinks"] = "HubspotCalendarLinks";
  return SettingsTypes;
}({});
export let ShippingMargin = /*#__PURE__*/function (ShippingMargin) {
  ShippingMargin["domesticShippingMargin"] = "domesticShippingMargin";
  ShippingMargin["internationalShippingMargin"] = "internationalShippingMargin";
  ShippingMargin["taxesAndDutiesMargin"] = "taxesAndDutiesMargin";
  return ShippingMargin;
}({});